import { TextSpan, Heading1, Heading2 } from '../../components/TextFormatting';

function Calls() {
    return (
        <div>
            <Heading1>Chamadas</Heading1>
            <Heading2>Graduação</Heading2>
            <TextSpan align='center'><a class='underline' href={require('./assets/GRA_PRH-9_2025-10_FluxoContínuo.pdf')}>Fluxo Contínuo – 2025/10</a></TextSpan>
            <Heading2>Mestrado</Heading2>
            <TextSpan align='center'>Seleção pela lista de aprovados do PEC</TextSpan>
            <Heading2>Doutorado</Heading2>
            <TextSpan align='center'>Seleção pela lista de aprovados do PEC</TextSpan>
        </div>
    );
  }

export { Calls }